import Axios from '../Axios';

const topUp = {
	create(data) {
		return Axios.post('/recharges', data);
	},
	read(limit = 10, page = 1, search) {
		return Axios.get(
			'/recharges?limit=' + limit + '&page=' + page + search
		);
	},
	readOne(id) {
		return Axios.get('/recharges/' + id);
	},
};

export default topUp;
